export default __webpack_public_path__ + "static/media/Siddhant.470b81ec.jpg";